import { render, staticRenderFns } from "./ClientesOrdensServico.vue?vue&type=template&id=a1e73c2e&scoped=true&"
import script from "./ClientesOrdensServico.vue?vue&type=script&lang=js&"
export * from "./ClientesOrdensServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e73c2e",
  null
  
)

export default component.exports